import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    baseURL: 'https://api.bursapark.com.tr',
    removeTitle: 'Uyarı!',
    removeMessage: 'Kayıt kalıcı olarak silinecektir! Devam etmek istiyor musunuz?',
    removeConfirm: 'Devam Et',
    removeCancel: 'Vazgeç',
    removeResultTitle: 'İşlem Başarılı!',
    removeResultMessage: 'Kayıt kalıcı olarak silinmiştir.!',
    removeResultClose: 'Kapat',
    revisedTitle: 'Projeyi Revize Etmek İstiyor Musunuz ?',
    revisedMessage: 'Mevcut kaydın durumu "Revize Edildi" olarak güncellenerek yeni revize kaydı açılacaktır.',
    revisedConfirm: 'Revize Et',
    revisedCancel: 'Vazgeç',
    revisedResultTitle: 'İşlem Başarılı',
    revisedResultMessage: 'Proje revize edilmiştir.',
    revisedResultClose: 'Kapat',
    perPage: 25,
    ProjectMarketingUserTypeId: '5', // proje pazarlamacısının diğer projeleri düzenlemesini kitler
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
  },
  actions: {},
}
